import { render } from "./UsageStatsDetail.vue?vue&type=template&id=5daea173&scoped=true"
import script from "./UsageStatsDetail.vue?vue&type=script&lang=js"
export * from "./UsageStatsDetail.vue?vue&type=script&lang=js"

import "./UsageStatsDetail.vue?vue&type=style&index=0&id=5daea173&scoped=true&lang=css"

import exportComponent from "C:\\Users\\hagino\\work\\src\\plus-manabi\\mplus-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5daea173"]])

export default __exports__